import { Box, CircularProgress, Fade, Zoom } from "@mui/material";
import { ReactNode, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MDBox from "../../components/MDBox";
import PopUp from "../../components/PopUp/PopUp";
import { IAuthState, tryConfirmLogin } from "../../stateManagement/reducers/authReducer";
import { IRootReducerT } from "../../stateManagement/reduxStore";
import WorkerDahboardLayouyt from "./WorkerDashboardLayout";

const HODashboardLayout = () => {

    const dispatch = useDispatch<any>();
    const { user, authToken, confirmingLogin } = useSelector<IRootReducerT, IAuthState>(state => state.auth);

    let layout: ReactNode | null = null;

    if (user?.role) {
        switch (user.role.name) {
            default:
                layout = <WorkerDahboardLayouyt />
                break;
        }
    }

    const [show, setShow] = useState(false);

    useEffect(() => {
        setShow(true);
        return () => {
            setShow(false);
        }
    }, []);


    useEffect(() => {
        dispatch(tryConfirmLogin({ authToken: authToken ?? "" }));
    }, []);

    return (
        <>
            <Fade in={show} style={{ transitionDelay: show ? '250ms' : '0ms', transitionDuration: '500ms' }}>
                <Box sx={{ height: "fit-ccontent" }}>
                    {layout}
                </Box>
            </Fade>
            {
                confirmingLogin

                &&

                <PopUp id='email-2FAOTP-PopUp' notCloseable deployed={confirmingLogin} setDeployed={(truth: boolean) => { }} >
                    <Box>
                        <CircularProgress color='info' />
                    </Box>
                </PopUp>
            }
        </>
    );
}

export default HODashboardLayout;